export const cookies = {
	COOKIES_REFERRAL_COUPON: "referral_cupom",
	COOKIE_LS_PARAMETERS: "lsparameters",
};
